var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "d-flex align-items-center": _vm.dot
      }
    },
    [
      _c(
        "div",
        {
          class: [
            _vm.bg,
            {
              border: _vm.withBorder,
              "rounded-circle mr-2": _vm.dot,
              "w-100  rounded-pill font-weight-bold": !_vm.dot
            }
          ]
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center",
              class: [
                _vm.pillContentClass,
                {
                  "justify-content-center": _vm.withBorder,
                  "p-03": _vm.dot,
                  "p-2": !_vm.dot
                }
              ]
            },
            [
              _vm.icon
                ? _c("em", {
                    staticClass: "fa-xs mr-2",
                    class: [_vm.icon, _vm.colorIcon]
                  })
                : _vm._e(),
              !_vm.dot
                ? _c("span", { class: _vm.color }, [_vm._v(_vm._s(_vm.text))])
                : _vm._e()
            ]
          )
        ]
      ),
      _vm.dot
        ? _c("span", { staticClass: "font-weight-bold", class: _vm.color }, [
            _vm._v(_vm._s(_vm.text))
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }